export default {
  LOADING_DASHBOARD: `Loading dashboard`,
  MISSING_PERMISSIONS: `You are missing all the permissions required to view information in this section.`,
  dailyUpdate: {
    TITLE: `Daily update`,
    SUMMARY: `This section gives you an idea of how the day is going.`,
    UNFILLEDSHIFTSTODAY: `View unfilled shifts <0>{{ count }} shift</0>`,
    UNFILLEDSHIFTSTODAY_other: `View unfilled shifts <0>{{ count }} shifts</0>`,
    REPLACEDSHIFTSTODAY: `View replaced shifts <0>{{ count }} shift</0>`,
    REPLACEDSHIFTSTODAY_other: `View replaced shifts <0>{{ count }} shifts</0>`,
    ABSENCESTODAY: `View absences <0>{{ count }} request</0>`,
    ABSENCESTODAY_other: `View absences <0>{{ count }} requests</0>`,
    LATESTODAY: `View late arrivals <0>{{ count }} request</0>`,
    LATESTODAY_other: `View late arrivals <0>{{ count }} requests</0>`,
    EARLYOUTTODAY: `View early departures <0>{{ count }} request</0>`,
    EARLYOUTTODAY_other: `View early departures <0>{{ count }} requests</0>`
  },
  actionsToDo: {
    TITLE: `Things to do`,
    SUMMARY: `This section gives you a quick list of tasks remaining to be done.`,
    ATTENDANCEREQUESTSINPROGRESS: `View attendance requests to acknowledge <0>{{ count }} request</0>`,
    ATTENDANCEREQUESTSINPROGRESS_other: `View attendance requests to acknowledge <0>{{ count }} requests</0>`,
    TIMEOFFREQUESTSINPROGRESS: `View time off requests to approve <0>{{ count }} request</0>`,
    TIMEOFFREQUESTSINPROGRESS_other: `View time off requests to approve <0>{{ count }} requests</0>`,
    AVAILABILITYREQUESTSTOAPPROVE: `View availability requests to approve <0>{{ count }} request</0>`,
    AVAILABILITYREQUESTSTOAPPROVE_other: `View availability requests to approve <0>{{ count }} requests</0>`,
    PUNCHCARDSNEEDACTION: `View punch cards that require action <0>{{ count }} punch card</0>`,
    PUNCHCARDSNEEDACTION_other: `View punch cards that require action <0>{{ count }} punch cards</0>`
  },
  quickActions: {
    TITLE: `Quick actions`,
    SUMMARY: `This section allows you to navigate quickly to a certain page.`,
    CREATEUSERACTION: `Create a user`,
    CREATEPUNCHCARDACTION: `Create a punch card`,
    CREATEATTENDANCEACTION: `Create an attendance request`,
    CREATETIMEOFFACTION: `Create a time off`,
    CREATELISTFORTODAYACTION: `Create a list with today's unassigned shift`,
    CREATELISTFORTOMORROWACTION: `Create a list with tomorrow's unassigned shift`
  }
}
